import styled from "styled-components"

const PopUp = styled.div`
  padding: ${({theme}) => theme.spacing.four};
  height: ${(props) => props.height + 2}px;
  width: 292px;
  background-color: ${(props) => props.color};
  border: 1px solid ${({theme}) => theme.colors.greys.mediumLight};
  border-radius: 5px;
  z-index: 1000;
  position: absolute;
  color: white;
  text-transform: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default PopUp
